export default __webpack_public_path__ + "static/laptop-d376a02912e285cfca7b771d7441d0cb.png";